import { View, StyleSheet } from 'react-native';
import FlashMessage from 'react-native-flash-message';
import { Text, theme, styles as baseStyles } from '@socrait/react';

import { ArchivedClassLayout } from '~/screens/archivedClass';
import { Period } from '~/services/types';

type ArchivedClassRosterScreenProps = {
  activePeriod: Period | null;
  onClose: () => void;
  onRestore: (period: Period, ref?: React.RefObject<FlashMessage>) => void;
  isRestoring?: boolean;
};

export function ArchivedClassRosterScreen({
  activePeriod,
  onClose,
  onRestore,
  isRestoring = false,
}: ArchivedClassRosterScreenProps) {
  const students = activePeriod?.students || [];

  return (
    <ArchivedClassLayout period={activePeriod} onClose={onClose} onRestore={onRestore} isRestoring={isRestoring}>
      <View style={styles.container}>
        <Text style={styles.studentCount}>
          {students.length} Student{`${students.length > 1 ? 's' : ''}`}
        </Text>
        <View style={styles.studentGrid}>
          {students.map((student) => {
            return (
              <View style={styles.studentItem}>
                <Text numberOfLines={1}>{student.voiceName}</Text>
              </View>
            );
          })}
        </View>
      </View>
    </ArchivedClassLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.gray,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: theme.spacing.xxlarge,
    gap: theme.spacing.xlarge,
  },
  studentCount: {
    ...baseStyles.boldText,
    fontSize: theme.fontSizes.small,
  },
  studentGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: 0,
    columnGap: theme.spacing.medium,
  },
  studentItem: {
    backgroundColor: theme.colors.white,
    borderBottomColor: theme.colors.gray,
    borderBottomWidth: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 50,
    justifyContent: 'center',
    minWidth: 100,
    paddingHorizontal: theme.spacing.xlarge,
    width: '24%',
  },
});
